<template>
  <div class="main-div">
    <v-card color="green lighten-4" class="main-card fill-height">
      <v-card-title>
        <span class="text-uppercase mr-4">{{ $t("menu.carddetail") }}</span>
        <span class="idcs-span-inline mr-10">
          <v-icon class="mr-3">fa-credit-card</v-icon>
          <span>{{ $route.params.id }}</span>
        </span>
        <span class="idcs-span-inline">
          <v-icon>fa-cogs</v-icon>
          <span class="ml-3">{{ cardSystem }}</span>
        </span>
        <v-spacer></v-spacer>
        <v-btn icon color="error" @click="$router.go(-1)">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="card-text-fill">
        <v-layout fluid v-show="loaded">
          <v-tabs background-color="transparent" v-model="tab" color="blue" show-arrows>
            <v-tab v-if="$store.getters.test('CardRecord')">{{ $t("card.common") }}</v-tab>
            <v-tab
              v-if="$store.getters.test('LogRecord,TransactionRecord')"
              :disabled="!isTimeLines"
            >{{ $t("card.timeline") }}</v-tab>
            <v-tab
              v-if="$store.getters.test('TransactionRecord')"
              :disabled="!isTransactions"
            >{{ $t("card.trans") }}</v-tab>
            <v-tab v-if="$store.getters.test('LogRecord')" :disabled="!isLogs">{{ $t("card.logs") }}</v-tab>
            <!-- info !-->
            <v-tab-item class="tab-item-main">
              <v-expansion-panels :value="mainPanels" multiple>
                <CardMainPanel
                  :icard.sync="card"
                  :vstart.sync="startValid"
                  :vend.sync="lastValid"
                  :trans="cardTransactions.length"
                  :logs="cardLog.length"
                />
                <!-- card details !-->
                <v-expansion-panel :disabled="!isDetail" class="idcs-main-back">
                  <v-expansion-panel-header v-slot="{ open }">
                    <v-layout align-center wrap>
                      <v-flex xs12 sm4 md3 lg2 xl2>
                        <v-subheader>
                          <v-icon class="mr-2 all-ok-icon-color">fa-file-invoice-dollar</v-icon>
                          {{ $t("card.accounts") }}
                        </v-subheader>
                      </v-flex>
                      <v-flex
                        xs12
                        sm8
                        md9
                        lg10
                        xl10
                        class="text-left"
                        v-show="
                        !open && (cardLog.length || cardTransactions.length)
                      "
                      >
                        <v-icon size="25" class>fa-money-check-alt</v-icon>
                        <v-icon small class="mx-6">fa-arrow-right</v-icon>
                        <span class="d-inline-block">
                          <span class="text-uppercase mr-4">{{ $t("card.debet") }}</span>
                          <span class="title">{{ debet | currency }}</span>
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table class="idcs-table-back">
                      <thead>
                        <tr>
                          <template v-for="f in cardDets">
                            <th
                              class="idcs-th-back"
                              :key="f.value"
                              :class="' text-' + f.align"
                            >{{ $t(f.name) }}</th>
                          </template>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in cardDetails" :key="item.id">
                          <template v-for="f in cardDets">
                            <td
                              class="idcs-data-back"
                              v-if="f.value == 'oper_nr' && item[f.value] != 0"
                              :key="f.value"
                              :align="f.align"
                            >{{ item[f.value] + "." }}</td>
                            <td
                              class="idcs-data-back"
                              v-else-if="
                              f.value == 'oper_nr' && item[f.value] == 0
                            "
                              :key="f.value"
                              :align="f.align"
                            >
                              <v-icon>fa-money-check-alt</v-icon>
                            </td>

                            <td
                              class="idcs-data-back"
                              v-else
                              :key="f.value"
                              :align="f.align"
                            >{{ autoformat(f.filter, item[f.value]) }}</td>
                          </template>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- card editor !-->
                <CardProfilePanel :cardo.sync="card" @cardUpdate="onUpdateRecord" />
                <!-- card stats !-->
                <CardStatPanel :card="card" :trans="cardTransactions.length" :logs="cardLog.length"></CardStatPanel>
              </v-expansion-panels>
            </v-tab-item>
            <!-- timeline !-->
            <v-tab-item class>
              <v-card fluid class="idcs-main-back">
                <v-card-actions>
                  <span v-if="byLog">
                    <span class="idcs-span-inline mr-4">
                      <v-icon color="white" class="idcs-legend-icon idcs-t-error mr-2">fa-bug</v-icon>
                      <span>{{ $t("card.legend.error") }}</span>
                    </span>
                    <span class="idcs-span-inline mr-4">
                      <v-icon color="white" class="idcs-legend-icon idcs-t-info mr-2">fa-info</v-icon>
                      <span>{{ $t("card.legend.info") }}</span>
                    </span>
                    <span class="idcs-span-inline">
                      <v-icon class="mr-2">fa-tv</v-icon>
                      <span>{{ $t("card.legend.display") }}</span>
                    </span>
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn-toggle
                    group
                    rounded
                    mandatory
                    v-model="byLog"
                    active-class="dummy-class"
                    color="teal"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn :value="false" class="ma-0 teal" v-on="on">
                          <span>{{$t("card.trans")}}</span>
                          <v-icon>mdi-handshake</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t("card.tooltip.trans")}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn :value="true" class="ma-0 teal" v-on="on">
                          <span>{{$t("card.logs")}}</span>
                          <v-icon>mdi-bug</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t("card.tooltip.logs")}}</span>
                    </v-tooltip>
                  </v-btn-toggle>
                  <v-btn-toggle
                    group
                    shaped
                    mandatory
                    v-model="reverse"
                    class="ml-4"
                    active-class="dummy-class"
                    color="blue"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn :value="false" class="ma-0 blue" v-on="on">
                          <v-icon>mdi-sort-ascending</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t("card.tooltip.asc")}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn :value="true" class="ma-0 blue" v-on="on">
                          <v-icon>mdi-sort-descending</v-icon>
                        </v-btn>
                      </template>
                      <span>{{$t("card.tooltip.desc")}}</span>
                    </v-tooltip>
                  </v-btn-toggle>
                </v-card-actions>
                <v-card-text>
                  <div class="d-flex justify-center title" style="margin-top: -20px;">
                    <v-chip v-if="!reverse" class="tl-start-end">
                      <span class="mr-2">{{ $t("card.from") }}</span>
                      <span>{{ startValid | dt-time }}</span>
                    </v-chip>
                    <v-chip v-else class="tl-start-end">
                      <span class="mr-2">{{ $t("card.to") }}</span>
                      <span>{{ $moment() | dt-time }}</span>
                    </v-chip>
                  </div>
                  <v-timeline>
                    <!--
                    !-->
                    <v-timeline-item
                      right
                      small
                      color="grey"
                      :icon="!reverse ? 'fa-angle-double-down' : 'fa-angle-double-up'"
                    ></v-timeline-item>
                    <v-timeline-item
                      v-for="rec in timeLineItems"
                      :key="rec.created"
                      :right="!tlLeft(rec)"
                      :color="tlColorIcon(rec)"
                      :left="tlLeft(rec)"
                      :icon="tlIcon(rec)"
                      :small="tlSmall(rec)"
                      fill-dot
                    >
                      <template v-slot:opposite>
                        <div class="d-flex flex-wrap" v-if="rec.status && rec.status == 200">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <div v-on="on">
                                <span>
                                  <v-icon
                                    class="mr-1"
                                    :color="tlColor(rec)"
                                  >{{ rec.amount2 ? "fa-plus" : "fa-minus" }}</v-icon>
                                  <span
                                    class="title mr-5"
                                    :style="{ color: tlColor(rec) }"
                                  >{{ (rec.amount1 ? rec.amount1 : rec.amount2) | currency }}</span>
                                </span>
                                <span class="idcs-span-inline">
                                  <v-icon class="mr-5">fa-arrow-right</v-icon>
                                  <v-icon class="mr-5">fa-credit-card</v-icon>
                                  <span class="title">{{ rec.debit_0 | currency }}</span>
                                </span>
                              </div>
                            </template>
                            <span>{{$t("card.tooltip.bilance")}}</span>
                          </v-tooltip>
                        </div>

                        <div class="d-flex flex-wrap" v-else-if="rec.status && rec.status == 201">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <div v-on="on">
                                <span class="idcs-span-inline">
                                  <v-icon class="mr-5">fa-arrow-right</v-icon>
                                  <v-icon class="mr-5">fa-credit-card</v-icon>
                                  <span class="title">{{ rec.debit_0 | currency }}</span>
                                </span>
                              </div>
                            </template>
                            <span>{{$t("card.tooltip.bilance")}}</span>
                          </v-tooltip>
                        </div>

                        <div class="d-flex flex-wrap" v-else-if="rec.status && rec.status == 202">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <div v-on="on">
                                <v-icon
                                  class="mr-1"
                                  :color="tlColor(rec)"
                                >{{ rec.amount2 ? "fa-plus" : "fa-minus" }}</v-icon>
                                <span
                                  class="title mr-5"
                                  :style="{ color: tlColor(rec) }"
                                >{{ (rec.amount1 ? rec.amount1 : rec.amount2) | currency }}</span>
                                <span class="idcs-span-inline">
                                  <v-icon class="mr-5">fa-arrow-right</v-icon>
                                  <v-icon class="mr-5">fa-credit-card</v-icon>
                                  <span class="title">{{ rec.debit_0 | currency }}</span>
                                </span>
                              </div>
                            </template>
                            <span>{{$t("card.tooltip.bilance")}}</span>
                          </v-tooltip>
                        </div>

                        <div
                          class="d-flex flex-wrap"
                          v-else-if="byLog && rec.code == 0 && rec.command != 1100"
                        >
                          <v-icon class="mr-5">fa-tv</v-icon>
                          <span class="title">{{ rec.message }}</span>
                        </div>
                        <div v-else-if="rec.code != 0 || rec.command == 1100">
                          <div>
                            <v-icon class="mr-5">fa-tv</v-icon>
                            <span class="title">{{ rec.message }}</span>
                          </div>
                          <div v-if="rec.resp3" class="title log-bilance">
                            <span class="mr-5">{{ rec.resp3 | currency }}</span>
                            <span>{{ $t("card.bilance") }}</span>
                          </div>
                        </div>
                      </template>
                      <component :is="byLog ? 'LogTLCard' : 'TransTLCard'" :record="rec"></component>
                    </v-timeline-item>
                    <v-timeline-item
                      right
                      small
                      color="grey"
                      :icon="!reverse ? 'fa-angle-double-down' : 'fa-angle-double-up'"
                    ></v-timeline-item>
                  </v-timeline>
                  <div class="d-flex justify-center title">
                    <v-chip v-if="reverse" class="tl-start-end">
                      <span class="mr-2">{{ $t("card.from") }}</span>
                      <span>{{ startValid | dt-time }}</span>
                    </v-chip>
                    <v-chip v-else class="tl-start-end">
                      <span class="mr-2">{{ $t("card.to") }}</span>
                      <span>{{ $moment() | dt-time }}</span>
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!-- trans !-->
            <v-tab-item>
              <CardTransactionsTable :items="cardTransactions" :columns="transCols" />
            </v-tab-item>
            <!-- log !-->
            <v-tab-item>
              <CardLogsTable :items="cardLog" :columns="logCols" />
            </v-tab-item>
          </v-tabs>
        </v-layout>
        <v-layout
          fluid
          fill-height
          v-show="!loaded"
          class="justify-center align-center progress-back"
        >
          <v-progress-circular :size="100" :width="7" color="green" indeterminate></v-progress-circular>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-snackbar top v-model="snackbar" dark :color="snackbarColor?'teal':'error'">
      {{snackbarMsg}}
      <v-btn icon @click="snackbar=false">
        <v-icon color="error">mdi-close-circle</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import app from "@/app.js";
//import { VueSvgGauge } from "vue-svg-gauge";
//import CardRecord from "@/components/editTypes/CardRecord.vue";
import LogTLCard from "@/components/LogTLCard0.vue";
import TransTLCard from "@/components/TransTLCard0.vue";
import CardTransactionsTable from "@/components/CardTransTable.vue";
import CardLogsTable from "@/components/CardLogsTable.vue";
import CardStatPanel from "@/components/CardStatPanel.vue";
import CardProfilePanel from "@/components/CardProfilePanel.vue";
import CardMainPanel from "@/components/CardMainPanel.vue";

function compare(a, b) {
  if (a.created < b.created) return 1;
  if (a.created > b.created) return -1;
  return 0;
}

export default {
  name: "Card-0",
  components: {
    /*VueSvgGauge,*/ /*CardRecord,*/
    LogTLCard,
    TransTLCard,
    CardStatPanel,
    CardMainPanel,
    CardProfilePanel,
    CardTransactionsTable,
    CardLogsTable
  },
  data() {
    return {
      snackbar: false,
      snackbarMsg: "ok",
      snackbarColor: false,
      loaded: false,
      byLogt: "",
      COLOR_MINUS: app.COLOR_MINUS,
      COLOR_PLUS: app.COLOR_PLUS,
      mainPanels: [0],
      editType: "Cardrecord",
      startValid: null,
      lastValid: null,
      byLog: false,
      reverse: false,
      tab: null,
      card: {},
      activated: null,
      cardDetails: [],
      cardTransactions: [],
      cardLog: [],
      //cardTimeLine: [],
      logCols: [
        {
          name: "card.field.created",
          value: "created",
          align: "left",
          filter: "dt-time"
        },
        { name: "field.subcompany", value: "subcompany", align: "center" },
        { name: "field.terminal", value: "terminal", align: "center" },
        {
          name: "card.field.command",
          value: "command",
          align: "center",
          filter: "command"
        },
        {
          name: "card.field.p1.0",
          value: "p1",
          filter: "currency",
          align: "right"
        },
        {
          name: "card.field.p2.0",
          value: "p2",
          filter: "currency",
          align: "right"
        },
        {
          name: "card.field.resp3",
          value: "resp3",
          filter: "currency",
          align: "right"
        },
        {
          name: "card.field.message",
          value: "message",
          align: "center"
        }
        // {
        //   name: "field.code",
        //   value: "code",
        //   align: "center",
        // },
      ],
      transCols: [
        {
          name: "card.field.created",
          value: "created",
          align: "left",
          filter: "dt-time"
        },
        { name: "field.subcompany", value: "subcompany", align: "center" },
        { name: "field.terminal", value: "terminal", align: "center" },
        {
          name: "field.status",
          value: "status",
          align: "center",
          filter: "status"
        },
        {
          name: "field.amount1.0",
          value: "amount1",
          align: "right",
          filter: "currency"
        },
        {
          name: "field.amount2.0",
          value: "amount2",
          align: "right",
          filter: "currency"
        },
        {
          name: "field.debit_0",
          value: "debit_0",
          align: "right",
          filter: "currency"
        }
        // {
        //   name: "field.debit_n",
        //   value: "debit_n",
        //   align: "right",
        //   filter: "currency"
        // }
      ],
      cardDets: [
        {
          name: "",
          value: "oper_nr"
        },
        {
          name: "card.acc.operation",
          value: "operation"
        },
        {
          name: "card.field.ocreated",
          value: "created",
          align: "center",
          filter: "dt-only"
        },
        {
          name: "field.debit_0",
          value: "amount_debit",
          align: "right",
          filter: "currency"
        },
        {
          name: "field.last_used",
          value: "last_used",
          align: "center",
          filter: "dt-time"
        },
        {
          name: "card.acc.used",
          value: "used",
          align: "center"
        },
        {
          name: "card.acc.valid",
          value: "valid",
          align: "right",
          filter: "dt-time"
        }
        // "amount_discount",
        // "current_discount",
        // "points_bonus",
        // "amount_bonus",
        //"status"
      ]
    };
  },
  mounted() {
    this.getCardInfo();
  },
  computed: {
    cardSystem() {
      try {
        return this.card.system ? this.card.system : "";
      } catch (e) {
        return "";
      }
    },
    isTimeLines() {
      try {
        return this.cardTransactions.length > 0 || this.cardLog.length > 0;
      } catch (e) {
        return false;
      }
    },
    isDetail() {
      try {
        return this.cardDetails.length > 0;
      } catch (e) {
        return false;
      }
    },
    isTransactions() {
      try {
        return this.cardTransactions.length > 0;
      } catch (e) {
        return false;
      }
    },
    isLogs() {
      try {
        return this.cardLog.length > 0;
      } catch (e) {
        return false;
      }
    },
    debet() {
      if (this.cardDetails.length == 0) return 0;
      let debet = 0;
      this.cardDetails.forEach(e => {
        if (e.oper_nr == 0) debet += e.amount_debit;
      });
      return debet;
    },
    timeLineItems() {
      if (this.byLog && this.cardLog) {
        return this.reverse ? this.cardLog.slice().sort(compare) : this.cardLog;
      } else if (this.cardTransactions.length) {
        return this.reverse
          ? this.cardTransactions.slice().sort(compare)
          : this.cardTransactions;
      }
      return [];
    }
  },
  methods: {
    onUpdateRecord() {
      this.getCardInfo(true);
    },
    onInsertRecord() {},
    onDeleteRecord() {},
    getCardInfo(s) {
      let card = this.$route.params.id;

      if (card.indexOf("=") != -1) {
        card = card.substr(0, card.indexOf("="));
      }
      app
        .getCardInfo(card, s)
        .then(response => {
          this.card = response.card;
          this.newStatus = this.card.status;
          this.newPin = this.card.pin;
          if (s) return;
          try {
            this.lastValid = this.$moment(this.card.valid);
          } catch (e) {
            this.lastValid = null;
          }
          this.startValid = this.$moment(this.card.created);
          this.cardDetails = response.details;
          this.cardDetails.forEach(e => {
            if (e.oper_nr == 0) {
              this.startValid = this.$moment(e.created);
            }
            let v = this.$moment(e.valid);
            if (v.isBefore(this.lastValid)) this.lastValid = v;
          });
          this.cardLog = response.logs;
          this.cardTransactions = response.trans;
          // if (this.cardLog.length > 0) {
          //   this.byLog = true;
          //   this.cardTimeLine = this.cardLog.slice().sort(compare);
          // } else {
          //   this.byLog = false;
          //   this.cardTimeLine = this.cardTransactions.slice().sort(compare);
          // }
          if (!this.cardLog.length && !this.cardTransactions.length)
            this.mainPanels = null;
          this.loaded = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    tlIcon(v) {
      if (v.command) {
        if (v.code != 0) return "fa-bug";
        if (v.command == 1100) return "fa-info";
      } else {
        //trans
        if (v.status == 200) {
          return v.amount1 ? "fa-shopping-cart" : "fa-money-bill-wave";
        }
        if (v.status == 201) return "fa-exclamation";
        if (v.status == 202) return "fa-times-circle";
      }
      return null;
    },
    tlColorIcon(v) {
      if (v.status) {
        if (v.status == 200) {
          return v.amount2 ? app.COLOR_PLUS : app.COLOR_MINUS;
        } else {
          return "#E0E0E0";
        }
      }
      if (v.code != 0) return "error";
      if (v.command == 1100) return "#FFECB3";
      return "#E0E0E0";
    },
    tlColor(v) {
      if (v.command) {
        // log
        if (v.code == 0 && v.command == 1200) {
          return v.p1 ? app.COLOR_MINUS : app.COLOR_PLUS;
        } else if (v.code != 0) {
          return "error";
        }
      } else {
        //trans

        if (v.status == 200) {
          return v.amount2 ? app.COLOR_PLUS : app.COLOR_MINUS;
        } else {
          return "#E0E0E0";
        }
      }
      return "secondary";
    },
    tlSmall(v) {
      if (v.command) {
        return (v.command == 1200 || v.command == 1300) && v.code == 0
          ? true
          : false;
      }
      return false;
    },
    tlLeft() {
      return true;
    },
    autoformat(col, val) {
      if (col == "dt-only") {
        return this.$options.filters["dt-only"](val);
      }
      if (col == "dt-time") return this.$options.filters["dt-time"](val);
      if (col == "currency") return this.$options.filters.currency(val);
      if (col == "amount1") return this.$options.filters.currency(val);
      if (col == "amount2") return this.$options.filters.currency(val);
      if (col == "debit_0") return this.$options.filters.currency(val);
      if (col == "debit_n") return this.$options.filters.currency(val);
      if (col == "amount_discount") return this.$options.filters.currency(val);
      if (col == "amount_debit") return this.$options.filters.currency(val);
      if (col == "amount_bonus") return this.$options.filters.currency(val);
      if (col == "last_used") return this.$options.filters["dt-time"](val);
      if (col == "created") return this.$options.filters["dt-only"](val);
      return val;
    }
  }
};
</script>
<style scoped>
.main-div {
  height: 100%;
  width: 100%;
}
.progress-back {
  background-image: url("../assets/GiftCard.svg");
  background-position: center center;
}
.card-text-fill {
  height: inherit;
}
.panel-header-background {
  background-color: #eeeeee;
}
.main-card {
  height: inherit;
  width: inherit;
}
.all-ok-icon-color {
  color: #81d4fa;
}
.v-item--active {
  border-radius: 25px !important;
}
.tab-item-main {
  background-color: #c8e6c9 !important;
}
.tl-start-end {
  background-color: #eeeeee !important;
}
.log-bilance {
  margin-right: 50px;
}
</style>
